"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchDarklyClient = void 0;
var axios_1 = __importDefault(require("axios"));
var LD = __importStar(require("launchdarkly-js-client-sdk"));
var REQUEST_OPTIONS = {
    withCredentials: true,
    headers: {
        Accept: 'application/json'
    },
};
var LaunchDarklyClient = /** @class */ (function () {
    function LaunchDarklyClient() {
    }
    /**
     * Creates a LaunchDarkly client
     * - Pass an api base url AND orgId to get an org user
     * - Pass no api base url OR orgId to get the global user
     * @param clientId
     * @param apiBaseUrl
     * @param orgId
     * @returns LaunchDarklyClient
     */
    LaunchDarklyClient.client = function (clientId, apiBaseUrl, orgId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._client && orgId === this._orgId && clientId === this._clientId && apiBaseUrl === this._apiBaseUrl) {
                            return [2 /*return*/, this._client];
                        }
                        this._clientId = clientId;
                        this._apiBaseUrl = apiBaseUrl;
                        this._orgId = orgId;
                        return [4 /*yield*/, this.initializeClient()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._client];
                }
            });
        });
    };
    LaunchDarklyClient.initializeClient = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.user()];
                    case 1:
                        user = _a.sent();
                        this._client = LD.initialize(this._clientId, user);
                        this._client.on('change', function () { }); // If feature is changed in LD, next variation check will be reflected
                        return [4 /*yield*/, this._client.waitUntilReady()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LaunchDarklyClient.affiliatedOrgUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url, options, orgName, result, response, err_1, organizations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { child_organization_id: this._orgId };
                        url = this._apiBaseUrl + "/affiliations/search";
                        options = __assign(__assign({}, REQUEST_OPTIONS), { params: params });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.get(url, options)];
                    case 2:
                        response = _a.sent();
                        result = response.data.result;
                        orgName = result[0].child_organization.name;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        return [2 /*return*/];
                    case 4:
                        organizations = result
                            .flatMap(function (affiliation) { return affiliation.ancestor_organization_ids; })
                            .concat(this._orgId)
                            .map(function (id) { return "se-organization-" + id; });
                        return [2 /*return*/, {
                                key: "se-organization-" + this._orgId,
                                name: orgName || this._orgId.toString(),
                                custom: {
                                    affiliation_path: organizations
                                }
                            }];
                }
            });
        });
    };
    LaunchDarklyClient.bossOrgUser = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var url, options, response, err_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this._apiBaseUrl + "/organization_public/" + this._orgId;
                        options = __assign({}, REQUEST_OPTIONS);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.get(url, options)];
                    case 2:
                        response = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _c.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, {
                            key: "se-organization-" + this._orgId,
                            name: ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.name) || this._orgId.toString(),
                            custom: {
                                affiliation_path: []
                            }
                        }];
                }
            });
        });
    };
    LaunchDarklyClient.user = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this._orgId || !this._apiBaseUrl) {
                            return [2 /*return*/, {
                                    key: 'sports-engine',
                                    name: 'SportsEngine'
                                }];
                        }
                        return [4 /*yield*/, this.affiliatedOrgUser()];
                    case 1:
                        _a = (_b.sent());
                        if (_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.bossOrgUser()];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3: return [2 /*return*/, _a];
                }
            });
        });
    };
    return LaunchDarklyClient;
}());
exports.LaunchDarklyClient = LaunchDarklyClient;
